<template>
    <div>
        <div class="container mx-auto text-center max-w-lg">
            <div class="px-3 py-2">
                <h2 v-text="$t('DELIVERY_DAY_WHEN_SHOULD')"></h2>
                <p v-html="$t('DELIVERY_DAY_PLEASE_CHOOSE', {
                'address.first_name': $t(`${address && address.first_name}`)})"></p>
            </div>
        </div>

        <div class="background--paper divider--container py-10">
            <div class="divider-white--top"></div>
            <div class="container mx-auto text-center max-w-lg">
                <delivery-day></delivery-day>
            </div>
            <div class="divider-white--bottom"></div>
        </div>

        <div v-if="address.sends_sms" class="container mx-auto text-center max-w-lg px-3 pt-6 pb-2 scroll-to-text-me">
            <p v-html="$t('DELIVERY_DAY_THE_COURIER', {
                'address.first_name': $t(`${address && address.first_name}`)})"></p>
        </div>

        <delivery-notification :validation.sync="formValidations.telephone"></delivery-notification>

        <div class="container mx-auto text-center max-w-lg">
            <div class="pb-10">
                <submit-button @click="submit" :disabled="isNextButtonDisabled" v-html="$t('DELIVERY_DAY_NEXT')">

                </submit-button>
            </div>
        </div>
    </div>
</template>

<script>
import { SECTION_DELIVERY_DATE } from '@/constants/Gifting';
import SubmitButton from '@/components/forms/buttons/SubmitButton';
import DeliveryDay from '@/components/partials/account/gifting/DeliveryDay';
import DeliveryNotification from '@/components/partials/account/gifting/DeliveryNotification';

export default {
    name: 'GiftDetails',
    methods: {
        submit() {
            this.$store.commit('gifting/setSectionComplete', SECTION_DELIVERY_DATE);
            this.$router.push({ name: 'account.gifting.gift-card' });
        },
    },
    data() {
        return {
            formValidations: {
                telephone: false,
            },
        };
    },
    computed: {
        address() {
            return this.$store.getters['address/getSelectedGiftingAddress'];
        },
        isNextButtonDisabled() {
            return this.formValidations.telephone !== true && Boolean(this.address.sends_sms);
        },
    },
    components: {
        SubmitButton,
        DeliveryDay,
        DeliveryNotification,
    },
};
</script>
